import { queryOptions, useQuery } from '@tanstack/react-query'
import { getFaqs } from '../services/getFaqs.service'
import { faqsKeys } from '../constants/faqs.queryKeys'

export const faqsQueryOptions = () =>
  queryOptions({
    queryKey: faqsKeys.list(),
    queryFn: getFaqs,
  })

export function useFaqs() {
  return useQuery(faqsQueryOptions())
}
